import characterData from "./characters.json";

export interface CharacterDefinition {
  id: string;
  name: string;
  tagline: string;
  /** Optional authoring fields used by future roster/story screens. */
  subtitle?: string;
  dialogue?: string;
  accent: string;
  /** Lightweight portrait for compact roster/profile UI. */
  icon: string;
  home: {
    lowImage: string;
    highImage: string;
    fallback?: {
      lowImage: string;
      highImage: string;
    };
    placement: HomeArtPlacement;
  };
  game: {
    sprite: string;
  };
}

export interface HomeArtPlacement {
  x: number;
  y: number;
  scale: number;
  anchorX: number;
  anchorY: number;
}

export const characters = characterData as CharacterDefinition[];
